export const ICON_SERVICE_URL = 'https://www.weavefox.cn/api/v1/infographic/icon';
